export interface IDispensingEventTbl {
	dispenseDate: Date;
	dispenseDateLocal: Date;
	strDispenseDateTime?: string;
	client?: string;
	site?: string;
	tankAssetNumber?: string;
	gallons?: number;
	personnel?: string;
	driverId?: number;
	emergencyEvent?: string;
	barcodeId: number;
	id: number;
	barcodeString?: string;
	tagNumber?: string;
	clientId?: number;
	unitId?: number;
	unit?: string;
	emergencyEventId?: number;
	assetId?: number;
	asset?: string;
	assetIds?: number[];
	assets?: string[];
	siteLocationId?: number;
	siteLocationName?: string;
	isUpdatedOffline: boolean;
	offlineBarcodeId?: any;
	fuelType?: string;
	fuelTypeId: number;
};

export class DispensingEventTbl implements IDispensingEventTbl {
	dispenseDate = new Date();
	dispenseDateLocal = new Date();
	strDispenseDateTime = '';
	client = '';
	site = '';
	tankAssetNumber = '';
	gallons = 0;
	personnel = '';
	driverId = 0;
	emergencyEvent = '';
	barcodeId = 0;
	id = 0;
	barcodeString = '';
	tagNumber = '';
	clientId = 0;
	unitId = 0;
	unit = '';
	emergencyEventId = 0;
	assetId = 0;
	asset = '';
	assetIds = [];
	assets = [];
	siteLocationId = 0;
	siteLocationName = '';
	isUpdatedOffline = false;
	offlineBarcodeId = '';
	fuelType = '';
	fuelTypeId = 0;
};
